import type { CSSProperties } from 'react';

export const FIELD = 'mz-field w-full rounded-xl px-3.5 py-2.5 text-sm outline-none';
export const FIELD_STYLE: CSSProperties = {
  border: '1.5px solid #f9c0d8',
  background: '#fff5f8',
  color: '#6b0030',
};
export const LABEL = 'mb-1 block text-xs font-semibold text-[#9d0050]';

export const CARD = 'rounded-2xl bg-white';
export const CARD_STYLE: CSSProperties = {
  border: '1px solid #fce7f3',
  boxShadow: '0 8px 28px rgba(157,0,80,0.06)',
};

export const BTN_PRIMARY =
  'mz-btn-primary inline-flex items-center justify-center gap-2 rounded-xl px-4 py-2.5 text-sm font-bold text-white disabled:cursor-not-allowed disabled:opacity-50';
export const BTN_PRIMARY_STYLE: CSSProperties = {
  background: '#d6006e',
  boxShadow: '0 8px 24px rgba(214,0,110,0.28)',
};

export const BTN_SOFT =
  'inline-flex items-center justify-center gap-1.5 rounded-xl px-3 py-2 text-xs font-bold text-[#d6006e] transition-colors hover:bg-[#fce7f3] disabled:cursor-not-allowed disabled:opacity-50';
export const BTN_SOFT_STYLE: CSSProperties = { background: '#fdf2f8', border: '1px solid #fce7f3' };

export const CHIP_ACTIVE = 'bg-[#d6006e] text-white shadow-[0_6px_16px_rgba(214,0,110,0.28)]';
export const CHIP_IDLE = 'bg-white text-[#6b0030] hover:bg-[#fdf2f8]';
